import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function SlackNode({ id, data, selected }) {
  const blockCount = Array.isArray(data.blocks) ? data.blocks.length : 0;
  const mode = data.messageMode || 'text';
  let summary = null;
  if (data.webhookUrl) {
    if (mode === 'blocks') {
      summary = blockCount > 0 ? `${blockCount} block${blockCount === 1 ? '' : 's'}` : 'Block builder (empty)';
    } else if (mode === 'raw') {
      summary = data.rawJson ? 'Raw Block Kit JSON' : 'Raw JSON (empty)';
    } else {
      summary = 'Webhook configured';
    }
  }

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.integrations}
      image={data.image || '/images/slackicon.png'}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
